import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  mdiEye,
  mdiEyeOff,
  mdiCheck,
  mdiCheckDecagram,
  mdiCheckDecagramOutline,
  mdiCancel,
  mdiClose,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCloseCircle,
  mdiMenuDown,
  mdiMenu,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowUp,
  mdiSend,
  mdiCheckboxMarkedCircleOutline,
  mdiMagnify,
  mdiViewDashboardOutline,
  mdiAccountEditOutline,
  mdiLogout,
  mdiAccount,
  mdiInformationOutline,
  mdiTextBoxSearch,
  mdiTextBoxSearchOutline,
  mdiExitToApp,
  mdiClipboardOutline,
  mdiAccountCircle,
  mdiChevronUp,
  mdiChevronDown,
  mdiPlay,
  mdiRestore,
  mdiStop,
  mdiContentSave,
  mdiCloseCircleOutline,
  mdiPencil,
  mdiDelete,
  mdiCheckboxMarkedCircle,
  mdiPlus,
  mdiBagPersonal,
  mdiFile,

  // ✅ Additions to cover Vuetify internals (date picker, alerts, radios, ratings, etc.)
  mdiChevronLeft,
  mdiChevronRight,
  mdiAlert,
  mdiAlertCircle,
  mdiMinusBox,
  mdiCircleSmall,
  mdiRadioboxMarked,
  mdiRadioboxBlank,
  mdiStar,
  mdiStarOutline,
  mdiStarHalfFull,
  mdiLoading,
  mdiPageFirst,
  mdiPageLast,
  mdiUnfoldMoreHorizontal,
  mdiMenuRight,
} from "@mdi/js";

// Usage '$vuetify.icons.xbox' or $xbox
const MY_ICONS = {
  // --- your custom aliases ---
  plus: mdiPlus,
  cancel1: mdiCloseCircleOutline,
  save: mdiContentSave,
  stop: mdiStop,
  loop: mdiRestore,
  play: mdiPlay,
  chevup: mdiChevronUp,
  chevdown: mdiChevronDown,
  person: mdiAccountCircle,
  person2: mdiBagPersonal,
  home: mdiAccountCircle, // (you had mdiHome imported earlier; you can swap back if you want)
  checkedcircle: mdiCheckboxMarkedCircle,

  // --- Vuetify "standard" icon keys (these are the ones components look up) ---
  eye: mdiEye,
  eyeoff: mdiEyeOff,
  complete: mdiCheck,

  cancel: mdiCancel,
  close: mdiClose,
  delete: mdiCloseCircle, // v-chip close, etc.
  clear: mdiClose,

  success: mdiCheck,
  successOutline: mdiCheckDecagramOutline,
  successBold: mdiCheckDecagram,

  info: mdiInformationOutline,
  warning: mdiAlert,
  error: mdiAlertCircle,

  // ✅ date picker + pagination + some navigation bits
  prev: mdiChevronLeft,
  next: mdiChevronRight,
  first: mdiPageFirst,
  last: mdiPageLast,

  // ✅ inputs
  checkboxOn: mdiCheckboxMarked,
  checkboxOff: mdiCheckboxBlankOutline,
  checkboxIndeterminate: mdiMinusBox,

  radioOn: mdiRadioboxMarked,
  radioOff: mdiRadioboxBlank,

  // ✅ sorting / menus / expansion
  sort: mdiArrowUp,
  expand: mdiMenuDown,
  menu: mdiMenu,
  subgroup: mdiMenuRight,
  dropdown: mdiMenuDown,

  // ✅ carousel dot / delimiter
  delimiter: mdiCircleSmall,

  // ✅ ratings
  ratingEmpty: mdiStarOutline,
  ratingFull: mdiStar,
  ratingHalf: mdiStarHalfFull,

  // ✅ loading spinners
  loading: mdiLoading,

  // --- your additional icons you already use by name ---
  arrowLeft: mdiArrowLeft,
  arrowRight: mdiArrowRight,
  send: mdiSend,
  checkboxMarkedOutline: mdiCheckboxMarkedCircleOutline,
  magnify: mdiMagnify,
  search: mdiMagnify,
  appViewDash: mdiViewDashboardOutline,
  accountEdit: mdiAccountEditOutline,
  logout: mdiLogout,
  account: mdiAccount,
  textSearch: mdiTextBoxSearch,
  textSearchOutline: mdiTextBoxSearchOutline,
  exitToApp: mdiExitToApp,
  clipboard: mdiClipboardOutline,

  edit: mdiPencil,
  del: mdiDelete,
  file: mdiFile,
};

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    // ✅ Important when you're using @mdi/js (SVG path strings)
    iconfont: "mdiSvg",
    values: MY_ICONS,
  },
  theme: {
    themes: {
      defaultTheme: "light",
      light: {
        reportback: "#ffffff",
        background: "#172815",
        primary: "#283a44",
        secondary: "#C8D5B9",
        accent: "#78806f",
        accent2: "#7D6F80",
        error: "#f44336",
        warning: "#ff9800",
        info: "#03a9f4",
        success: "#4caf50",
        cmpbk: "#002e42",
        cmpbkinside: "#ECEFF1",
        whitesmoke: "#f5f5f5",
      },
    },
    options: {
      customProperties: true,
    },
  },
});